module.exports = __webpack_public_path__ + "static/media/pacRoyale-preview.bc1ce366.png";